import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from 'react-immutable-proptypes';
import Component from "components/component";

export const INPUT_HEIGHT = 42;

export default class ComDetailsForm extends Component {
  static propTypes = {
    manufacturer: PropTypes.string,
    name: PropTypes.string,
    width: PropTypes.number,
    yards: PropTypes.number,
    squareFeet: PropTypes.number,
    repeat: PropTypes.string,
    content: PropTypes.string,
    editComDetailField: PropTypes.func.isRequired,
  };

  handleChange = (field, e) => {
    this.props.editComDetailField(field, e.target.value);
  };

  render() {
    const {
      manufacturer,
      name,
      width,
      yards,
      squareFeet,
      repeat,
      content,
      type,
    } = this.props;

    // TODO(jared) remove this?
    const errors = {};

    const isCom = type === 'fabric_com';
    const isCol = type === 'fabric_col';
    const isSpecialtyCom = type === 'specialty_com';

    return (
      <form className="com-details-form">
        <div className="input-wrap">
          <input
            className={errorsClass("manufacturer", errors)}
            style={{ height: INPUT_HEIGHT }}
            type="text"
            defaultValue={manufacturer}
            placeholder="Manufacturer"
            onChange={this.handleChange.bind(this, "manufacturer")}
          />

          <div className="error-notice">{errors["manufacturer"]}</div>
        </div>

        <div className="input-wrap">
          <input
            className={errorsClass("name", errors)}
            style={{ height: INPUT_HEIGHT }}
            type="text"
            defaultValue={name}
            placeholder="Name/Color/#"
            onChange={this.handleChange.bind(this, "name")}
          />

          <div className="error-notice">{errors["name"]}</div>
        </div>

        {isSpecialtyCom && (
          <div className="input-wrap">
            <input
              className={errorsClass("repeat", errors)}
              style={{ height: INPUT_HEIGHT }}
              type="text"
              defaultValue={repeat}
              placeholder="Repeat"
              onChange={this.handleChange.bind(this, "repeat")}
            />

            <div className="error-notice">{errors["repeat"]}</div>
          </div>
        )}

        {(isCom || isSpecialtyCom) && (
          <div className="input-wrap">
            <input
              className={errorsClass("width",errors)}
              style={{ height: INPUT_HEIGHT }}
              type="number"
              defaultValue={width}
              placeholder="Width (inches)"
              onChange={this.handleChange.bind(this, "width")}
            />

            <div className="error-notice">{errors["width"]}</div>
          </div>
        )}

        {(isCom || isSpecialtyCom) && (
          <div className="input-wrap">
            <input
              className={errorsClass("yards", errors)}
              style={{ height: INPUT_HEIGHT }}
              type="number"
              defaultValue={yards}
              placeholder="Yardage (yards)"
              onChange={this.handleChange.bind(this, "yards")}
            />

            <div className="error-notice">{errors["yards"]}</div>
          </div>
        )}

        {(isCom || isSpecialtyCom) && (
          <div className="input-wrap">
            <input
              className={errorsClass("content", errors)}
              style={{ height: INPUT_HEIGHT }}
              type="text"
              defaultValue={content}
              placeholder="Fabric Content"
              onChange={this.handleChange.bind(this, "content")}
            />

            <div className="error-notice">{errors["content"]}</div>
          </div>
        )}

        {isCol && (
          <div className="input-wrap">
            <input
              style={{ height: INPUT_HEIGHT }}
              className={errorsClass("square_feet", errors)}
              type="number"
              defaultValue={squareFeet}
              placeholder="Square Feet (sq.ft)"
              onChange={this.handleChange.bind(this, "square_feet")}
            />

            <div className="error-notice">{errors["square_feet"]}</div>
          </div>
        )}
      </form>
    );
  }
}

function errorsClass(field, errors) {
  if (errors[field]) {
    return "text-input error";
  } else {
    return "text-input";
  }
}
